import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const topBar: ThemeApp['appComponents']['topBar'] = {
  components: {
    superAgentIndicator: {
      text: {
        defaultColor: themeUi.semantic.color.text.secondary700,
        notificationColor: themeUi.semantic.color.text.neutral100
      }
    },
    envBanner: {
      hrefText: {
        color: themeUi.semantic.color.text.neutral100,
        colors: themeUi.semantic.color.text
      },
      iconContainer: {
        fill: themeUi.semantic.color.icon.neutral100
      },
      verticalLine: {
        backgroundColor: themeUi.semantic.color.text.neutral100
      }
    },

    userMenu: {
      userMenu: {
        nameAndArrowContainer: {
          notifyColor: themeUi.semantic.color.text.secondary950,
          unnotifyColor: themeUi.semantic.color.text.secondary950
        },
        userName: {
          notifyColor: themeUi.semantic.color.text.secondary700,
          unnotifyColor: themeUi.semantic.color.text.secondary700,
          fontSize: themeUi.core.font.fontSize.s12
        },
        menuContainer: {
          notifyColor: themeUi.semantic.color.text.primary400,
          unnotifyColor: themeUi.semantic.color.text.primary400,

          notifyBackgroundColor: themeUi.semantic.color.background.primary0,
          unnotifyBackgroundColor: themeUi.semantic.color.background.primary0,

          fill: themeUi.semantic.color.icon.primary400
        },
        arrowIcon: {
          fill: themeUi.semantic.color.icon.secondary950
        }
      },

      components: {
        userMenuContent: {
          userMenuContent: {
            container: {
              color: themeUi.semantic.color.text.secondary950
            },
            editProfileIcon: {
              fill: themeUi.semantic.color.icon.secondary700
            },
            signOutIcon: {
              stroke: themeUi.semantic.color.icon.secondary700
            },
            menuActionItem: {
              borderTop: themeUi.semantic.color.border.neutral400,
              backgroundColor: themeUi.semantic.color.text.neutral300
            },
            userName: {
              color: themeUi.semantic.color.text.secondary700
            }
          },

          components: {
            switchAccount: {
              accountNameAndId: {
                selectedColor: themeUi.semantic.color.text.primary600,
                unselectedColor: themeUi.semantic.color.text.secondary700,
                gap: themeUi.core.space.space100
              },
              accountItem: {
                backgroundColor: themeUi.semantic.color.background.neutral300
              }
            }
          }
        }
      }
    }
  }
};

export default topBar;
